<template>

    <v-navigation-drawer app class="left-menu" v-model="appStore.AppHelpers.ShowNavigation" :width="360">

        <v-row class="fill-height">
            <v-col class="d-flex flex-column justify-space-between">

                <!-- Top navigation -->
                <v-list nav class="left-menu__top-nav">

                    <!-- Dashboard -->
                    <v-list-item title="Domov" :to="{ name: 'dashboard_dashboard' }"
                        :prepend-icon="route.matched.some(x => x.name == 'dashboard_dashboard') ? 'custom:iconMenuDomovActive' : 'custom:iconMenuDomovInactive'">
                    </v-list-item>

                    <!-- Seznam pogodb -->
                    <v-list-item title="Moje pogodbe" :to="{ name: 'osnovni_seznam' }"
                        :prepend-icon="route.matched.some(x => x.name == 'osnovni_seznam') ? 'custom:iconMenuPogodbeActive' : 'custom:iconMenuPogodbeInactive'"></v-list-item>

                    <!-- Plačilo predračuna -->
                    <v-list-item title="Plačilo predračuna" :to="{ name: 'predracun' }"
                        :prepend-icon="route.matched.some(x => x.name == 'predracun') ? 'custom:iconMenuPredracunActive' : 'custom:iconMenuPredracunInactive'"></v-list-item>

                    <!-- Izračun obrokov -->
                    <v-list-item title="Izračun obrokov" :to="{ name: 'izracun_obrokov' }"
                        :prepend-icon="route.matched.some(x => x.name == 'izracun_obrokov') ? 'custom:iconMenuIzracunObrokaActive' : 'custom:iconMenuIzracunObrokaInactive'"></v-list-item>


                    <!-- Mobile links -->
                    <div class="d-lg-none">
                        <hr class="hr mt-8 mb-8"> 

                        <!-- Pogosta vprašanja -->
                        <v-list-item title="Pogosta vprašanja"
                            href="https://www.nlbbuygo.si/nlb-buy-go/pogosta-vprasanja/sem-kupec" target="_blank"
                            :prepend-icon="route.matched.some(x => x.name == 'pogosta_vprasanja') ? 'custom:iconAppBarFaqActive' : 'custom:iconAppBarFaqInactive'"></v-list-item>

                        <!-- Informacije (uporabniški center) -->
                        <v-list-item title="Informacije" :to="{ name: 'informacije_home' }"
                            :prepend-icon="route.matched.some(x => x.name == 'informacije_home') ? 'custom:iconAppBarInformacijeActive' : 'custom:iconAppBarInformacijeInactive'"></v-list-item>

                        <!-- Splošni pogoji -->
                        <v-list-item title="Splošni pogoji" href="https://www.nlbbuygo.si/nlb-buy-go/pravna-vsebina"
                            target="_blank"
                            :prepend-icon="route.matched.some(x => x.name == 'splosni_pogoji') ? 'custom:iconAppBarConditionsActive' : 'custom:iconAppBarConditionsInactive'"></v-list-item>

                        <!-- Kontakt -->
                        <v-list-item title="Kontakt" :to="{ name: 'kontakt' }"
                            :prepend-icon="route.matched.some(x => x.name == 'kontakt') ? 'custom:iconAppBarContactActive' : 'custom:iconAppBarContactInactive'"></v-list-item>
                    </div>

                </v-list>

            </v-col>
        </v-row>

    </v-navigation-drawer>

</template>

<script setup lang="ts">
    import { useRoute } from "vue-router";
    import { useAppStore } from "@/app/store/app/app-store";

    const route = useRoute();
    const appStore = useAppStore();
</script>